import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import { processNestedCSS } from '@sds-system/utils/styledUtils/nestedCSS';
import type { StyledRadioInputProps } from './Radio.types';

export const StyledRadioInput = styled('input')<StyledRadioInputProps>(
  ({ theme }) => {
    return {
      all: 'unset',
      position: 'relative',
      width: '24px',
      height: '24px',
      margin: 0,
      border: `1.5px solid ${theme.palette.border.secondary}`,
      borderRadius: theme.borderRadius[999],
      boxSizing: 'border-box',
      cursor: 'pointer',
      '&:disabled': processNestedCSS(
        {
          cursor: 'not-allowed',

          '&:checked': processNestedCSS(
            {
              border: `1.5px solid ${theme.palette.border.secondary}`,
              '&:before': processNestedCSS(
                {
                  backgroundColor: theme.palette.border.secondary,
                },
                theme,
              ),
            },
            theme,
          ),
        },
        theme,
      ),
      '&:before': processNestedCSS(
        {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 0,
          height: 0,
          transition: 'all 0.4s ease',
        },
        theme,
      ),
      '&:checked': processNestedCSS(
        {
          border: `1.5px solid ${theme.palette.border.interactive.primary}`,
          '&:before': processNestedCSS(
            {
              borderRadius: '50%',
              display: 'inline-block',
              width: '12px',
              height: '12px',
              backgroundColor: theme.palette.border.interactive.primary,
            },
            theme,
          ),
        },
        theme,
      ),
    };
  },
  ({ theme }) => ({
    variants: [
      {
        props: { sizeType: 'XS' },
        style: {
          width: '24px',
          height: '24px',

          '&:checked': processNestedCSS(
            {
              '&:before': processNestedCSS(
                {
                  width: '12px',
                  height: '12px',
                },
                theme,
              ),
            },
            theme,
          ),
        },
      },
      {
        props: { sizeType: '2XS' },
        style: {
          width: '20px',
          height: '20px',

          '&:checked': processNestedCSS(
            {
              '&:before': processNestedCSS(
                {
                  width: '10px',
                  height: '10px',
                },
                theme,
              ),
            },
            theme,
          ),
        },
      },
    ],
  }),
  ...getAllStyledProps,
);
